import moment from "moment";
import type { Moment } from "moment";
export default function combineDateTime(date: string, time: Moment, utcOffset?: number) {
    const combine = utcOffset !== undefined ? moment(date).utcOffset(utcOffset, true) : moment(date);
    if (time) {
        const t = moment(time);
        combine.hour(t.hour());
        combine.minute(t.minute());
        combine.seconds(t.seconds());
    }
    return combine;
}
